import React from 'react';
import { FormattedMessage } from 'react-intl';
import NegativeToast from '@/components/toasts/NegativeToast';

const UsersGroupsRemoveSuccessToast = ({ groups }) => (
  <NegativeToast className="aridhia-users-groups-remove-success-toast">
    {groups.length === 1 && (
      <FormattedMessage
        id="users.groups.toast.remove.success"
        values={{ name: groups[0].name }}
      />
    )}
    {groups.length > 1 && (
      <FormattedMessage
        id="users.groups.toast.remove.successes"
        values={{ name: groups[0].name, count: groups.length - 1 }}
      />
    )}
  </NegativeToast>
);

export default UsersGroupsRemoveSuccessToast;
